import { isEqual } from '../../../../lib/utilities';
import {ReduceStore} from 'flux/utils';
import Dispatcher from '../../dispatcher';
import ACTION_TYPES from '../../constants/action_types';
import ProductBatchStocksModel from '../models/product_batch_stocks';
import ProductBatchStocksConstants from '../../constants/product_batch_stocks_constants';

class ActiveProductBatchStocksStoreClass extends ReduceStore {
    getInitialState() {
        return {
            activeProductBatchStocks: null,
        };
    }
    reduce(state, {source, action}) {
        const { type } = action;

        if (source === ACTION_TYPES.PRODUCT_BATCH_STOCKS_ACTION) {
            switch (type) {
                case ProductBatchStocksConstants.SET_ACTIVE_PRODUCT_BATCH_STOCKS:
                    if (!isEqual(state.activeProductBatchStocks, action.payload)) {
                        state.activeProductBatchStocks = new ProductBatchStocksModel(action.payload);
                        this.__emitChange();
                    }
                    break;

                case ProductBatchStocksConstants.UNSET_ACTIVE_PRODUCT_BATCH_STOCKS:
                    state.activeProductBatchStocks = null;
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const ActiveProductBatchStocksStore = new ActiveProductBatchStocksStoreClass(Dispatcher);
export default ActiveProductBatchStocksStore;
